/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ChatEventTypeEnum =
  | 'textReceived'
  | 'textUpdated'
  | 'textDeleted'
  | 'emodjiReceived'
  | 'emodjiRemoved'
  | 'fileReceived'
  | 'fileDeleted'
  | 'chatCreated'
  | 'directChatCreated'
  | 'directChatEdited'
  | 'chatEdited'
  | 'chatMemberAdded'
  | 'chatAdminAdded'
  | 'chatMemberRemoved'
  | 'chatAdminRemoved'
  | 'chatDeleted'
  | 'userOnline'
  | 'userOffline'
  | 'chatUserJoined'
  | 'userLeftChat'
  | 'messageDelivered'
  | 'messageRead'
  | 'reactionsChanged'
  | 'lastMessageChanged'
  | 'lastReadMessageChanged'
  | 'chatSettingsChanged'
  | 'messengerBadgeUpdated'
  | 'messengerPublicChatBadgeUpdated'
  | 'fileGroupReceived'
  | 'userEdited';

export const ChatEventTypeEnum = {
  TextReceived: 'textReceived' as ChatEventTypeEnum,
  TextUpdated: 'textUpdated' as ChatEventTypeEnum,
  TextDeleted: 'textDeleted' as ChatEventTypeEnum,
  EmodjiReceived: 'emodjiReceived' as ChatEventTypeEnum,
  EmodjiRemoved: 'emodjiRemoved' as ChatEventTypeEnum,
  FileReceived: 'fileReceived' as ChatEventTypeEnum,
  FileDeleted: 'fileDeleted' as ChatEventTypeEnum,
  ChatCreated: 'chatCreated' as ChatEventTypeEnum,
  DirectChatCreated: 'directChatCreated' as ChatEventTypeEnum,
  DirectChatEdited: 'directChatEdited' as ChatEventTypeEnum,
  ChatEdited: 'chatEdited' as ChatEventTypeEnum,
  ChatMemberAdded: 'chatMemberAdded' as ChatEventTypeEnum,
  ChatAdminAdded: 'chatAdminAdded' as ChatEventTypeEnum,
  ChatMemberRemoved: 'chatMemberRemoved' as ChatEventTypeEnum,
  ChatAdminRemoved: 'chatAdminRemoved' as ChatEventTypeEnum,
  ChatDeleted: 'chatDeleted' as ChatEventTypeEnum,
  UserOnline: 'userOnline' as ChatEventTypeEnum,
  UserOffline: 'userOffline' as ChatEventTypeEnum,
  ChatUserJoined: 'chatUserJoined' as ChatEventTypeEnum,
  UserLeftChat: 'userLeftChat' as ChatEventTypeEnum,
  MessageDelivered: 'messageDelivered' as ChatEventTypeEnum,
  MessageRead: 'messageRead' as ChatEventTypeEnum,
  ReactionsChanged: 'reactionsChanged' as ChatEventTypeEnum,
  LastMessageChanged: 'lastMessageChanged' as ChatEventTypeEnum,
  LastReadMessageChanged: 'lastReadMessageChanged' as ChatEventTypeEnum,
  ChatSettingsChanged: 'chatSettingsChanged' as ChatEventTypeEnum,
  MessengerBadgeUpdated: 'messengerBadgeUpdated' as ChatEventTypeEnum,
  MessengerPublicChatBadgeUpdated: 'messengerPublicChatBadgeUpdated' as ChatEventTypeEnum,
  FileGroupReceived: 'fileGroupReceived' as ChatEventTypeEnum,
  UserEdited: 'userEdited' as ChatEventTypeEnum,
};
